import { render } from "./DateRange.vue?vue&type=template&id=1e4eb216"
import script from "./DateRange.vue?vue&type=script&lang=js"
export * from "./DateRange.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__